import type React from "react";
import { useCallback } from "react";

import { useVideoCallContext } from "contexts/VideoCallContext";

import { VideoCall } from "./views/VideoCall";

export const VideoCallRoute: React.FC = () => {
  const { callData, setCallData, videoCallMode, setVideoCallMode } = useVideoCallContext();

  const endCall = useCallback(() => {
    setCallData(null);
    setVideoCallMode("docked");
  }, [setCallData, setVideoCallMode]);

  return (
    <>
      {callData && (
        <VideoCall
          callData={callData}
          videoCallMode={videoCallMode}
          setVideoCallMode={setVideoCallMode}
          onCallEnded={endCall}
        />
      )}
    </>
  );
};

export * from "./types";
